import {useDispatch, useSelector} from "react-redux";
import {setLoanReportRequestData, setLoanReportResponseData} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {toast} from "react-toastify";
import {Button, Col, Row, Spinner} from "react-bootstrap";
import Input from "../../../common/Input";
import Pagination from "../../../primer/Pagination";
import moment from "moment";
import {getGreekCurrencyFormat, getGreekNumberFormat} from "../../../../_helpers/commonFunctions";
import {openLoanLocal} from "../../../../_helpers/tabOpeners";

const LoanReport = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const requestData = useSelector((state) => state.CASH_DATA.loanReportRequestData);
    const responseData = useSelector((state) => state.CASH_DATA.loanReportResponseData);
    const setRequestData = (data) => dispatch(setLoanReportRequestData(data));
    const setResponseData = (data) => dispatch(setLoanReportResponseData(data));

    const [pageChanged, setPageChanged] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged])

    const fetchReport = (fromPagination = false) => {
        setLoading(true);
        const reqData = {...requestData};
        if (!fromPagination) {
            reqData.page = 1;
            setRequestData(reqData);
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/cash/loan-report`, {
            ...reqData,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                setResponseData(res.data);
                if (!fromPagination) toast.success("Επιτυχής ανανέωση δεδομένων.", {autoClose: 1000});
            } else {
                if (!fromPagination) toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        })
    }

    const onPageChange = (page) => {
        setPageChanged(true);
        setRequestData({...requestData, page});
    }

    const handleFilterChange = (e, type, name) => {
        const prepChange = {};
        if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "dd") {
            prepChange[name] = e.value;
        }
        setRequestData({...requestData, ...prepChange});
    }

    const onDoubleClick = (loan) => {
        dispatch(openLoanLocal(loan, TABS_DATA));
    }

    return (
        <div>
            <div onKeyDown={(e) => {
                if (e.key === "Enter") fetchReport(false);
            }}>
                <Row className={"mb-2"}>
                    <Col md={3}>
                        <Input
                            name={"numbering"}
                            label={"Κωδικός Δανείου"}
                            value={requestData.numbering}
                            onChange={(e) => handleFilterChange(e, "input", "numbering")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            name={"principalFrom"}
                            label={"Ποσό κεφαλαίου από"}
                            type={"number"}
                            value={requestData.amountFrom}
                            onChange={(e) => handleFilterChange(e, "input", "principalFrom")}
                        />
                    </Col>
                    <Col md={2}>
                        <Input
                            name={"principalTo"}
                            label={"Ποσό κεφαλαίου έως"}
                            type={"number"}
                            value={requestData.amountTo}
                            onChange={(e) => handleFilterChange(e, "input", "principalTo")}
                        />
                    </Col>
                    <Col md={5} className={"d-flex justify-content-end"}>
                        <Button style={{marginTop: "23px"}} onClick={() => fetchReport(false)} disabled={loading}>
                            Εφαρμογή Φίλτρων {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Col>
                </Row>
            </div>
            {responseData.totalPages > 0 && (
                <React.Fragment>
                    <Row className={"mb-2 mt-2"}>
                        <Col md={12} className="d-flex flex-column flex-md-row justify-content-end align-items-center align-items-md-start">
                            <div className="mr-md-3 mt-2 mb-2 mb-md-0 text-center text-md-right">
                                <i style={{ whiteSpace: 'nowrap' }}>
                                    Σύνολο Αποτελεσμάτων: {responseData.totalItems}
                                </i>
                            </div>
                            <div className="d-flex justify-content-center justify-content-md-end">
                                <Pagination
                                    currentPage={requestData.page}
                                    totalPages={responseData.totalPages}
                                    handlePageChange={(e) => onPageChange(e)}
                                    maxWidth={400}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <table className={"transfers-table"}>
                                <thead>
                                <tr>
                                    <th>Κωδικός Δανείου</th>
                                    <th>Ημ/νια Έναρξης</th>
                                    <th>Επιτόκιο</th>
                                    <th>Διάρκεια σε έτη</th>
                                    <th>Κεφάλαιο Δανεισμού</th>
                                    <th>Υπολοιπόμενο Κεφάλαιο</th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData.data.map((loan, idx) => (
                                    <tr key={`loan-${idx}`} onDoubleClick={() => onDoubleClick(loan)}>
                                        <td>{loan.numbering}</td>
                                        <td>{moment(loan.startData).format("DD/MM/YYYY")}</td>
                                        <td>{getGreekNumberFormat(loan.interestRate)} %</td>
                                        <td>{loan.years}</td>
                                        <td>{getGreekCurrencyFormat(loan.principal)}</td>
                                        <td>{getGreekCurrencyFormat(loan.remainingPrincipal)}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row className={"mt-3 d-flex justify-content-end"}>
                        <Col md={4}>
                            <table className={"transfers-table"}>
                                <thead>
                                <tr>
                                    <th colSpan={2}>Σύνολα</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td style={{fontWeight: 600}}>Συνολικό Κεφάλαιο Δανεισμού</td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.principal)}</td>
                                </tr>
                                <tr>
                                    <td style={{fontWeight: 600}}>Συνολικό Υπόλοιπο</td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.remainingPrincipal)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </div>
    )
}

export default LoanReport;
